import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./text-link.css.ts.vanilla.css-mistica.js";
var v = {
    default: "_1m1n0pr1 _1y2v1nfbt _1y2v1nfb8 _1y2v1nfe4 _1y2v1nf27",
    inverseLight: "_1m1n0pr6 _1m1n0pr1 _1y2v1nfbt _1y2v1nfb8 _1y2v1nfe4 _1y2v1nf28",
    inverseDark: "_1m1n0pr7 _1m1n0pr1 _1y2v1nfbt _1y2v1nfb8 _1y2v1nfe4 _1y2v1nf27"
};
export { v as variants };
